"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.vehiclePropType = exports.taxesPropType = exports.taxPropType = exports.rebatePropType = exports.pricePropType = exports.modelYearPropType = exports.modelFeesPropType = exports.modelFeePropType = exports.formDataPropType = exports.dataPropType = exports.calculationPropType = exports.additionalPriceGroupPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var vehiclePropType = exports.vehiclePropType = _propTypes["default"].shape({
  modelName: _propTypes["default"].string,
  msrpValueDisplay: _propTypes["default"].string,
  imageAltText: _propTypes["default"].string,
  imagePath: _propTypes["default"].string,
  keyFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
var modelYearPropType = exports.modelYearPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  year: _propTypes["default"].string.isRequired
});
var dataPropType = exports.dataPropType = _propTypes["default"].shape({
  descriptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string,
    text: _propTypes["default"].string
  })),
  shareOfferLabel: _propTypes["default"].string,
  // TODO: update isRequired once BE updated
  shareOfferDialogLabel: _propTypes["default"].string,
  // TODO: update isRequired once BE updated
  vehicleName: _propTypes["default"].string.isRequired,
  paymentCalculatorLabel: _propTypes["default"].string.isRequired,
  msrpLabel: _propTypes["default"].string.isRequired,
  ctaText: _propTypes["default"].string.isRequired,
  ctaUrl: _propTypes["default"].string.isRequired,
  vehicles: _propTypes["default"].arrayOf(vehiclePropType),
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
var additionalPriceGroupPropType = exports.additionalPriceGroupPropType = _propTypes["default"].shape({
  color: _propTypes["default"].number,
  colorCode: _propTypes["default"].string,
  fabric: _propTypes["default"].number,
  fabricCode: _propTypes["default"].string,
  "package": _propTypes["default"].number,
  packageCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  accessory: _propTypes["default"].number,
  accessoryCodes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  destinationFees: _propTypes["default"].number
});
var pricePropType = exports.pricePropType = _propTypes["default"].shape({
  displayValue: _propTypes["default"].string,
  value: _propTypes["default"].number
});
var taxPropType = exports.taxPropType = _propTypes["default"].shape({
  taxName: _propTypes["default"].string,
  taxValue: pricePropType
});
var taxesPropType = exports.taxesPropType = _propTypes["default"].arrayOf(taxPropType);
var modelFeePropType = exports.modelFeePropType = _propTypes["default"].shape({
  feeAmount: pricePropType,
  feeCode: _propTypes["default"].string,
  feeName: _propTypes["default"].string
});
var modelFeesPropType = exports.modelFeesPropType = _propTypes["default"].arrayOf(modelFeePropType);
var calculationPropType = exports.calculationPropType = _propTypes["default"].shape({
  modelFees: modelFeesPropType,
  modelPrice: pricePropType,
  subTotal: pricePropType,
  totalSellingPrice: pricePropType,
  interestRate: pricePropType,
  totalDueOnDelivery: pricePropType,
  costOfBorrowing: pricePropType,
  totalPayable: pricePropType,
  taxes: taxesPropType,
  monthlyPaymentDisplayValue: _propTypes["default"].string,
  firstPaymentDisplayValue: _propTypes["default"].string,
  breakdown: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    details: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string,
      value: _propTypes["default"].string,
      themeStyle: _propTypes["default"].string
    }))
  }))
});
var rebatePropType = exports.rebatePropType = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  code: _propTypes["default"].string,
  pretax: _propTypes["default"].number
});
var formDataPropType = exports.formDataPropType = _propTypes["default"].shape({
  $parsed: _propTypes["default"].bool,
  $defaultRate: _propTypes["default"].number,
  isDefaultRate: _propTypes["default"].bool,
  interestRate: _propTypes["default"].number,
  financeTerm: _propTypes["default"].number,
  leaseTerm: _propTypes["default"].number,
  leaseAnnualMileage: _propTypes["default"].number,
  tradeInValue: _propTypes["default"].number,
  downPaymentAmount: _propTypes["default"].number,
  includeTax: _propTypes["default"].bool,
  includeFee: _propTypes["default"].bool,
  rebates: _propTypes["default"].arrayOf(_propTypes["default"].string),
  financeDownPayment: _propTypes["default"].number,
  leaseDownPayment: _propTypes["default"].number,
  leasePaymentFrequency: _propTypes["default"].string,
  financePaymentFrequency: _propTypes["default"].string,
  financeTradeInValue: _propTypes["default"].number,
  leaseTradeInValue: _propTypes["default"].number,
  cashTradeInValue: _propTypes["default"].number
});